module.exports = __webpack_public_path__ + "static/img/kuaishou.83ddd594.png";